import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountLeadsBoard implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLeadsBoardContainer";
    }
    render(){
        // progressive enhancement: drag a card to another column; the Move to select/button keeps working without JS
        let self=this;
        let drag:HTMLElement|null=null;
        let root=this.zidx.peakidxShadowRoot;
        $(".zidxAccountLeadsBoardContainer .zidxBoardCard", root).each(function(this:HTMLElement) {
            let card=this;
            card.addEventListener("dragstart", function(e:DragEvent){
                drag=card;
                if(e.dataTransfer){
                    e.dataTransfer.effectAllowed="move";
                    e.dataTransfer.setData("text/plain", card.getAttribute("data-lead-id")||"");
                }
            });
            card.addEventListener("dragend", function(){ drag=null; });
        });
        $(".zidxAccountLeadsBoardContainer .zidxBoardCol", root).each(function(this:HTMLElement) {
            let col=this;
            col.addEventListener("dragover", function(e:DragEvent){
                if(drag){
                    e.preventDefault();
                    col.style.outline="2px dashed #888";
                }
            });
            col.addEventListener("dragleave", function(){ col.style.outline=""; });
            col.addEventListener("drop", function(e:DragEvent){
                e.preventDefault();
                col.style.outline="";
                if(!drag || drag.parentNode===col) return;
                let card=drag;
                col.appendChild(card);
                card.style.opacity="0.5";
                let reload=function(){ window.location.reload(); };
                self.zidx.ajaxRequest({
                    id: "ajaxLeadBoardMoveStage",
                    method: "post",
                    url: self.zidx.getAbsoluteURL("/account/leads/move-stage"),
                    postObj: {
                        lead_id: card.getAttribute("data-lead-id"),
                        lead_pipeline_stage_id: col.getAttribute("data-stage-id")
                    },
                    callback: reload,
                    errorCallback: reload
                });
            });
        });
    }
}
